/**
 * Remittance support API (banks, beneficiaries, exchange rates).
 * Operations live in the existing /api/operations endpoints.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const h = (getAuthHeaders) => ({ headers: getAuthHeaders() });

// Banks
export const listBanks = async (getAuthHeaders, country) => {
  const qs = country ? `?country=${encodeURIComponent(country)}` : '';
  return (await axios.get(`${API}/remittance/banks${qs}`, h(getAuthHeaders))).data;
};
export const createBank   = async (getAuthHeaders, payload) => (await axios.post(`${API}/admin/remittance/banks`, payload, h(getAuthHeaders))).data;
export const updateBank   = async (getAuthHeaders, id, patch) => (await axios.patch(`${API}/admin/remittance/banks/${id}`, patch, h(getAuthHeaders))).data;
export const archiveBank  = async (getAuthHeaders, id) => (await axios.delete(`${API}/admin/remittance/banks/${id}`, h(getAuthHeaders))).data;

// Beneficiaries (gestor self-service)
export const listMyBeneficiaries  = async (getAuthHeaders) => (await axios.get(`${API}/gestor/me/beneficiaries`, h(getAuthHeaders))).data;
export const createMyBeneficiary  = async (getAuthHeaders, payload) => (await axios.post(`${API}/gestor/me/beneficiaries`, payload, h(getAuthHeaders))).data;
export const updateMyBeneficiary  = async (getAuthHeaders, id, patch) => (await axios.patch(`${API}/gestor/me/beneficiaries/${id}`, patch, h(getAuthHeaders))).data;
export const archiveMyBeneficiary = async (getAuthHeaders, id) => (await axios.delete(`${API}/gestor/me/beneficiaries/${id}`, h(getAuthHeaders))).data;

// Exchange rates
export const listRates  = async (getAuthHeaders) => (await axios.get(`${API}/remittance/exchange-rates`, h(getAuthHeaders))).data;
export const upsertRate = async (getAuthHeaders, payload) => (await axios.post(`${API}/admin/remittance/exchange-rates`, payload, h(getAuthHeaders))).data;

// Operations
export const createOperation = async (getAuthHeaders, payload) => (await axios.post(`${API}/operations`, payload, h(getAuthHeaders))).data;
export const listOperationsByType = async (getAuthHeaders, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v && qs.set(k, v));
  return (await axios.get(`${API}/operations?${qs}`, h(getAuthHeaders))).data;
};
